import { useTranslation } from "react-i18next";
import { Team as TeamFeature } from "@/partner/features/team";
import { Meta } from "@/shared/components";

export function TeamPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("menu.team")} pageType="Partner" />
      <TeamFeature />
    </>
  );
}
